// «السعر». Night, with three glass cards where the reference has its licences.
// REFERENCE.md §10, spec section 5.
//
// Every number on a card comes from the live CMS overlay, put together by
// data.js buildPriceCards: one plan on sale gives free month, monthly, yearly;
// several give a card each; and a card whose number is unknown is already gone.
// With no plan on sale `cards` is empty and the section renders nothing; the nav
// and the footer already drop «السعر» in that case.

import { BadgeCheck, CalendarDays, CalendarRange, Gift } from "lucide-react";
import CtaLink from "./CtaLink";
import SectionHead from "./SectionHead";
import { PRICE_LABELS } from "./copy";
import { Capture } from "./media";
import "./PricingBand.css";

const ICONS = { trial: Gift, monthly: CalendarDays, yearly: CalendarRange };

export default function PricingBand({ pricing, cards, finePrint, aside = PRICE_LABELS.aside }) {
    if (!cards.length) return null;
    return (
        <section className="ld-section ld-section--night ld-pricing" id="pricing" aria-labelledby="ld-pricing-title">
            <div className="ld-decor" aria-hidden="true">
                <div className="ld-gridlines" style={{ "--ld-grid-at": "20% 80%" }} />
                <div className="ld-grain" />
            </div>
            <div className="ld-container">
                <SectionHead
                    id="ld-pricing-title"
                    eyebrow={pricing.eyebrow}
                    title={pricing.title}
                    lead={pricing.subtitle}
                    aside={<a className="ld-ghost" href="#faq">{aside}</a>}
                />
                <ul className="ld-pricing__cards" data-ld="cards">
                    {cards.map((card) => {
                        const Icon = ICONS[card.id] || BadgeCheck;
                        return (
                            <li key={card.id}>
                                <article className="ld-pricing__card ld-glass-night-lite">
                                    <div className="ld-pricing__head">
                                        <span className="ld-disc ld-disc--sm"><Icon aria-hidden="true" /></span>
                                        <div className="ld-pricing__name">
                                            {card.kicker ? <p className="ld-label ld-pricing__kicker">{card.kicker}</p> : null}
                                            <h3 className="ld-pricing__title">{card.title}</h3>
                                        </div>
                                        <span className="ld-pricing__thumb">
                                            <Capture name={card.capture} sizes="4rem" alt="" className="ld-pricing__shot" />
                                        </span>
                                    </div>
                                    <dl className="ld-pricing__cells">
                                        {card.cells.map((cell) => (
                                            <div className="ld-pricing__cell" key={cell.label}>
                                                <dt className="ld-label ld-pricing__label">{cell.label}</dt>
                                                <dd className="ld-pricing__value">{cell.value}</dd>
                                            </div>
                                        ))}
                                    </dl>
                                    <div className="ld-pricing__actions">
                                        <CtaLink href={card.cta.href} className="ld-btn ld-btn--secondary ld-btn--sm">
                                            {card.cta.text}
                                            <span className="ld-pricing__hit" aria-hidden="true" />
                                        </CtaLink>
                                    </div>
                                </article>
                            </li>
                        );
                    })}
                </ul>
                <div className="ld-pricing__notes" data-ld="rise">
                    <p className="ld-small">{finePrint}</p>
                    {pricing.footnote ? <p className="ld-small">{pricing.footnote}</p> : null}
                </div>
            </div>
        </section>
    );
}
